import { render, staticRenderFns } from "./ContentOfferUpload.vue?vue&type=template&id=38e20cf9&scoped=true&"
import script from "./ContentOfferUpload.vue?vue&type=script&lang=js&"
export * from "./ContentOfferUpload.vue?vue&type=script&lang=js&"
import style0 from "./ContentOfferUpload.vue?vue&type=style&index=0&id=38e20cf9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e20cf9",
  null
  
)

export default component.exports